import { Application } from "@listat/r2-core";

const core = new Application();
const coreCrypto = core.lib.crypto;
const coreDevice = core.lib.device;
const coreLogger = (printLogs: boolean) => {
    core.lib.logger.printLogs = printLogs
    return core.lib.logger
}

export {
    core,
    coreCrypto,
    coreDevice,
    coreLogger
}

export default core;
